<template>
    <div>
        <p>About {{ entity.name || entity.full_name }}</p>
        <wysiwyg-editor
            class="mt-5"
            v-bind:value.sync="entity.notes"
            :height="500"
        ></wysiwyg-editor>
    </div>
</template>
<script>
export default {
    props: {
        entity: Object,
    },
    data() {
        return {};
    },
    components: {
        WysiwygEditor: function() {
            return import("@/js/components/partials/wysiwyg-editor");
        },
    },
    watch: {
        "entity.notes": {
            handler(to, from) {},
            deep: true,
        },
    },
};
</script>
